import { render, staticRenderFns } from "./MdjRsltContent.vue?vue&type=template&id=a6e32faa&"
import script from "./MdjRsltContent.vue?vue&type=script&lang=js&"
export * from "./MdjRsltContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports